var map = {
	"./1/bottom-left-1.png": "1yVe",
	"./2/bottom-left-1.png": "6P8H",
	"./3/bottom-left-1.png": "Md1B",
	"./4/bottom-left-1.png": "8zqS",
	"./5/bottom-left-1.png": "lOyR",
	"./6/bottom-left-1.png": "QSoS",
	"./7/bottom-left-1.png": "FHwD",
	"./8/bottom-left-1.png": "R0hM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "iMAU";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/bottom\-left\-1\.png$
// module id = iMAU
// module chunks = 1